import { Button, FormControl, Grid, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import React, { useState } from "react";
import useGlobalStyles from "../../../services/useGlobalStyles";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import Container from "@mui/material/Container";
import FormNewVendor from "./FormNewVendor";
import LanguageSelect from "../../../components/LanguageSelect";

let useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function NewVendor() {
    let globalClasses = useGlobalStyles();
    let classes = useStyles();
    let history = useHistory();
    let { t, i18n } = useTranslation();
    let [showForm, setShowForm] = useState(false);

    function goToLogin() {
        history.push('login');
    }

    function goToNewVendorForm() {
        setShowForm(true);
    }

    return (
        !showForm ?
            <Container component="main" maxWidth="xs">
                <FormControl sx={
                    {
                        m: 6,
                        minWidth: 120,
                        position: 'absolute',
                        top:0,
                        left:0
                    }
                } size="small">
                    <LanguageSelect value={i18n.language} onChange={({ target }) => i18n.changeLanguage(target.value)} color='black' />
                </FormControl>
                <Grid className={classes.paper} container>
                    <Typography variant={'h6'} sx={{ mt: 4 }}>
                        {t('alreadyPinbiker')}
                    </Typography>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={() => {
                            goToLogin()
                        }}
                    >
                        {t('loginToRegister')}
                    </Button>
                    <Typography variant={'h6'}>
                        {t('orElseRegister')}
                    </Typography>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={() => {
                            goToNewVendorForm()
                        }}
                    >
                        {t('register')}
                    </Button>
                </Grid>
            </Container>
            :
            <FormNewVendor goBack={() => setShowForm(false)} />
    );
}
